import { Box, BoxProps, LinkButton } from '@homebotapp/hb-react-component-catalog'
import { NavigationShortcutDatum } from '../../../types/navigation'

export interface SidebarItemProps extends BoxProps {
  option: NavigationShortcutDatum
}

export const SidebarItem = ({ option, ...layoutProps }) => {
  const isButton = !option.href && option.onClick
  const role = isButton ? 'button' : undefined

  return (
    <Box as='li' {...layoutProps}>
      <LinkButton
        role={role}
        onClick={option.onClick}
        href={option.href || '#'}
        variant='ghost'
        tracking={option.tracking}
        size='xs'
        width='100%'
        border='none'
        justifyContent='flex-start'
        leftIcon={option.icon}
        // CSS for Spanish translation support
        height='auto'
        minHeight='8'
        whiteSpace='pre-wrap'
      >
        {option.body}
      </LinkButton>
    </Box>
  )
}
